const Rule = {
    "App\\Models\\Field": function(rule, answers, customer = null){
        let ret = false;
        let steps = Object.keys(answers).map((key) => [answers[key]]);
        steps.map(step => {
            step.map(val => {
                if(val[rule.value_of_id]){
                    ret = eval(`'${val[rule.value_of_id]}' ${rule.operator} '${rule.value}'`);
                }
            })
        });

        return ret;
    },
  "App\\Models\\Customer": function(rule, answers, customer = null) {
        return eval(`'${customer[rule.field]}' ${rule.operator} '${rule.value}'`);
  }
}

export default Rule;



// WEBPACK FOOTER //
// ./src/components/FormBuilder/DisplayRulesFunctions.js